import script from "./submit14.vue?vue&type=script&setup=true&lang=js"
export * from "./submit14.vue?vue&type=script&setup=true&lang=js"

import "./submit14.vue?vue&type=style&index=0&id=a6975ede&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6975ede"]])

export default __exports__